import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminFormsComponent } from './shared/layout/admin-forms/admin-forms.component';


const routes: Routes = [
  { path: '', redirectTo: '/forms/captures/pendings', pathMatch: 'full' },
  { path: 'forms', loadChildren: () => import('./forms/forms.module').then(m => m.FormsModule) },
  { path: 'formulas', component: AdminFormsComponent, loadChildren: () => import('./formulas/formulas.module').then(m => m.FormulasModule) },
  { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
  { path: 'plants', loadChildren: () => import('./plants/plants.module').then(m => m.PlantsModule) },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'supportive', loadChildren: () => import('./supportive/supportive.module').then(m => m.SupportiveModule) },
  { path: 'onboarding', loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule) },
  { path: 'tools', component: AdminFormsComponent, loadChildren: () => import('./tools/tools.module').then(m => m.ToolsModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
